import ManagementTeamModal from "modal/ManagementTeamModal";

export default function handleManagementTeamBlocks() {
    $('body').on('click', '.js-team-modal', function () {
        const $this = $(this);
        try {
            let data = JSON.parse($this.find('.js-modal-content').text());
            (new ManagementTeamModal(data)).show();
        } catch (e) {
            console.log('Could not load modal content', e);
        }

        return false;
    });
}
